"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavMenu = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _Icon = require("../Icon/Icon");
var _IconButton = require("../IconButton/IconButton");
var _Tooltip = require("../Tooltip/Tooltip");
var _Button = require("../Buttons/Button");
var _Overlay = require("../Overlay/Overlay");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useTypeToFocus2 = require("../utils/useTypeToFocus");
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuBar = require("./NavMenuBar");
var _NavMenuGroup = require("./NavMenuGroup");
var _NavMenuItem = require("./NavMenuItem");
var _NavMenu = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-nav-menu';
/**
 * **NavMenu** together with **NavMenu.Group**, **NavMenu.Item**,
 * or **NavMenu.Bar**; is used
 * to present a menu of navigational links. These can be
 * nested to create sub-menus.
 */
var NavMenu = exports.NavMenu = (0, _assign.default)( /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _a, _b, _c, _d, _e;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _f = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(NavMenu, props)) : props,
    show = _f.show,
    size = _f.size,
    ariaCurrent = _f.ariaCurrent,
    ariaLabel = _f.ariaLabel,
    disabled = _f.disabled,
    buttonContents = _f.buttonContents,
    buttonRef = _f.buttonRef,
    buttonProps = _f.buttonProps,
    children = _f.children,
    className = _f.className,
    overlayProps = _f.overlayProps,
    hoverToOpen = _f.hoverToOpen,
    iconName = _f.iconName,
    inNavMenuBar = _f.inNavMenuBar,
    menuAriaLabel = _f.menuAriaLabel,
    iconProps = _f.iconProps,
    listProps = _f.listProps,
    maxHeight = _f.maxHeight,
    moveFocusAndOpenNew = _f.moveFocusAndOpenNew,
    onShow = _f.onShow,
    onHide = _f.onHide,
    inToolbarOverflow = _f.inToolbarOverflow,
    tooltipMessage = _f.tooltipMessage,
    tooltipProps = _f.tooltipProps,
    wrapperProps = __rest(_f, ["show", "size", "ariaCurrent", "ariaLabel", "disabled", "buttonContents", "buttonRef", "buttonProps", "children", "className", "overlayProps", "hoverToOpen", "iconName", "inNavMenuBar", "menuAriaLabel", "iconProps", "listProps", "maxHeight", "moveFocusAndOpenNew", "onShow", "onHide", "inToolbarOverflow", "tooltipMessage", "tooltipProps"]);
  var _useState = (0, _react.useState)(show),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var classnames = _bind.default.bind(_NavMenu.default);
  var internalButtonRef = (0, _react.useRef)(null);
  var internalListRef = (0, _react.useRef)(null);
  var classes = classnames("".concat(CSS_BLOCK, "__container"), className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--disabled"), disabled));
  (0, _react.useEffect)(function () {
    if (children) {
      if (isOpen) {
        onShow === null || onShow === void 0 ? void 0 : onShow();
      } else if (isOpen === false) {
        onHide === null || onHide === void 0 ? void 0 : onHide();
      }
    }
  }, [isOpen, children]);
  var handleToggle = function handleToggle() {
    setIsOpen(!isOpen);
  };
  var handleHide = function handleHide() {
    setIsOpen(false);
  };
  var hideAndFocus = function hideAndFocus(focusDirection) {
    var _a, _b;
    handleHide();
    (_b = (_a = internalButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (focusDirection === 'left' || focusDirection === 'right') {
      moveFocusAndOpenNew === null || moveFocusAndOpenNew === void 0 ? void 0 : moveFocusAndOpenNew(internalButtonRef.current, focusDirection);
    }
  };
  // in toolbar overflow, pressing left should close
  // the nav menu and focus the trigger.
  var handleMenuKeydown = function handleMenuKeydown(event) {
    if (inToolbarOverflow) {
      if ((0, _keycode.default)(event) === 'left') {
        hideAndFocus('');
      }
    }
  };
  var handleButtonKeyDown = function handleButtonKeyDown(event) {
    var _context;
    if (disabled) return;
    if (inToolbarOverflow) {
      // in toolbar overflow, pressing down on the nav menu button
      // should do nothing because down is reserved for tabbing to the next
      // item in the overflow menu
      if ((0, _keycode.default)(event) === 'down') return;
      // in toolbar overflow, pressing right on the nav menu button
      // should open it
      if ((0, _keycode.default)(event) === 'right') {
        event.preventDefault();
        setIsOpen(true);
      }
    }
    if ((0, _includes.default)(_context = ['enter', 'space', 'down']).call(_context, (0, _keycode.default)(event))) {
      event.preventDefault();
      setIsOpen(!isOpen);
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (hoverToOpen) {
      setIsOpen(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (hoverToOpen) {
      setIsOpen(false);
    }
  };
  var passChildProps = function passChildProps(child) {
    // support both MenuButtonItem in NavMenu for help-portal
    // because we need to support actions and links in the same help menu
    if (child.displayName === 'NavMenuItem' || child.displayName === 'MenuButtonItem') {
      return {
        inToolbarOverflow: inToolbarOverflow,
        hideMainMenu: hideAndFocus,
        hoverToOpen: hoverToOpen,
        inNavMenuBar: inNavMenuBar,
        size: size,
        level: 0
      };
    }
    return {};
  };
  var handlePopperMouseEnter = function handlePopperMouseEnter() {
    if (hoverToOpen) {
      setIsOpen(true);
    }
  };
  var handlePopperMouseLeave = function handlePopperMouseLeave() {
    if (hoverToOpen) {
      setIsOpen(false);
    }
  };
  var _useTypeToFocus = (0, _useTypeToFocus2.useTypeToFocus)({
      focusCandidates: (0, _from.default)(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
      keyStrokeTimeout: 50,
      focusMatchingItem: _navMenuUtils.focusMatchingItem
    }),
    handleTypeToFocus = _useTypeToFocus.handleTypeToFocus;
  var additionalButtonProps = {
    role: inNavMenuBar ? 'menuitem' : undefined,
    size: size,
    disabled: disabled,
    allowFocusOnDisable: disabled,
    // In an a11y review with Vinay
    // he mentioned being able to focus on disabled
    // items will be a better experience for AT users.
    'aria-current': !!ariaCurrent || undefined,
    'aria-haspopup': true,
    'aria-expanded': isOpen,
    ref: buttonRef ? (0, _reactMergeRefs.default)([buttonRef, internalButtonRef]) : internalButtonRef,
    onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onMouseEnter),
    onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onMouseLeave),
    onClick: (0, _chainFunction.default)(handleToggle, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick),
    onKeyDown: (0, _chainFunction.default)(handleButtonKeyDown, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onKeyDown)
  };
  var button = /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _assign.default)({
    type: "link"
  }, buttonProps, additionalButtonProps, {
    className: classnames("".concat(CSS_BLOCK, "__toggle"), buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__toggle--md"), size === 'md'), "".concat(CSS_BLOCK, "__toggle--current"), !!ariaCurrent), "".concat(CSS_BLOCK, "__toggle--disabled"), !!disabled)),
    innerTextClasses: classnames(
    // @ts-expect-error innerTextClasses exists on button, not iconButton
    buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerTextClasses, "".concat(CSS_BLOCK, "__toggle-text"))
  }), buttonContents, /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _assign.default)({
    ariaHidden: true,
    iconName: "arrow-2-s",
    forceSize: size === 'md' ? 'xs' : 'xs-plus'
  }, iconProps)));
  var wrappedButton = tooltipMessage && !inToolbarOverflow && !isOpen ? ( /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, (0, _assign.default)({}, tooltipProps, {
    message: tooltipMessage
  }), button)) : button;
  var menuOverlay = /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, (0, _assign.default)({
    popperPlacement: ['bottom-start', 'bottom-end', 'top-start', 'top-end', 'bottom', 'top', 'auto']
  }, overlayProps, {
    show: isOpen,
    onShow: function onShow() {
      return setIsOpen(true);
    },
    innerDialogClassName: classnames("".concat(CSS_BLOCK, "__inner-dialog")),
    onHide: handleHide,
    onClickOutside: function onClickOutside(event) {
      return (0, _navMenuUtils.handleOutsideClick)(event, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onClickOutside, handleHide);
    },
    popperProps: (0, _assign.default)((0, _assign.default)({
      role: 'presentation'
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      onMouseEnter: (0, _chainFunction.default)(handlePopperMouseEnter, (_b = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _b === void 0 ? void 0 : _b.onMouseEnter),
      onMouseLeave: (0, _chainFunction.default)(handlePopperMouseLeave, (_c = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _c === void 0 ? void 0 : _c.onMouseLeave),
      'data-overflow-flyout': 'true',
      'data-nui-widgets': 'menu-overlay'
    }),
    popperContentProps: (0, _assign.default)((0, _assign.default)({}, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps), {
      className: classnames((_d = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps) === null || _d === void 0 ? void 0 : _d.className, "".concat(CSS_BLOCK, "__overlay")),
      style: (0, _assign.default)({
        maxHeight: maxHeight
      }, (_e = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps) === null || _e === void 0 ? void 0 : _e.style)
    }),
    targetComponent: buttonContents ? wrappedButton : ( /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _assign.default)({}, buttonProps, additionalButtonProps, {
      className: classnames("".concat(CSS_BLOCK, "__toggleicon"), buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__toggleicon--md"), size === 'md'), "".concat(CSS_BLOCK, "__toggleicon--current"), !!ariaCurrent), "".concat(CSS_BLOCK, "__toggleicon--disabled"), !!disabled)),
      ariaLabel: ariaLabel,
      iconName: iconName
    }))),
    focusManagerProps: {
      nextKeyCode: _keycode.default.codes.down,
      previousKeyCode: _keycode.default.codes.up,
      trapWithTabbing: true,
      onlyContainedEvents: true,
      useHomeAndEndKeys: true
    }
  }), /*#__PURE__*/_react.default.createElement("ul", (0, _assign.default)({}, listProps, {
    role: "menu",
    className: classnames(CSS_BLOCK, listProps === null || listProps === void 0 ? void 0 : listProps.className),
    "aria-label": menuAriaLabel,
    onKeyDown: (0, _chainFunction.default)(handleTypeToFocus, handleMenuKeydown, listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown),
    ref: (listProps === null || listProps === void 0 ? void 0 : listProps.ref) ? (0, _reactMergeRefs.default)([listProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children)));
  return inNavMenuBar ? ( /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, wrapperProps, {
    role: "none",
    ref: ref,
    className: classes
  }), menuOverlay)) : ( /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, wrapperProps, {
    ref: ref,
    className: classes
  }), menuOverlay));
}), {
  displayName: 'NavMenu',
  Bar: _NavMenuBar.NavMenuBar,
  Group: _NavMenuGroup.NavMenuGroup,
  Item: _NavMenuItem.NavMenuItem
});
var _default = exports.default = NavMenu;